import React from "react";
//* NDBX
import { Section } from "@arp/react-ndbx";
//* MUI
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
//* Component
import { Discount } from "./Discount.jsx";
//* Hooks
import { useGetQuote } from "../../../hooks/dataHooks/useGetQuoteData.js";
// import { useGetInterviewOutcome } from "../../../hooks/dataHooks/useGetInterviewOutcome.js";
import useNewBusiness from "../../../hooks/useNewBusiness.ts";

//* Conntext
import useSharedData from "../../../hooks/useSharedData.ts";
//** Utilities */
import { formatCurrency } from "../../../utilities/numericFormat.js";

//----------------------------------------------------------------
export const SingleQuoteSummary = ({ ...props }) => {
  const {
    firstName,
    frequency,
    displayName = true,
    isPreQualStage = true, //* Do we get the data from useGetQuote or useGetInterviewOutcome API hook.
  } = { ...props };

  const { data, isLoading, isFetching, error } = isPreQualStage
    ? useGetQuote()
    : useNewBusiness();

  const { quoteInformation } = { ...data };

  const { policyPremiumsTotal, discountPercentage } = { ...quoteInformation };

  const { isCoverStateValid } = useSharedData();

  const frequencyDisplay = { monthly: "monthly", annual: "yearly" };
  //* We don't want to show the discount component under any circumstance atm
  //* if in future we want to show, set the  ? false to true
  //* Note: we may need to determine if we are in Online or CC,
  //* use the application flag for this.
  // const discountApplied = discountPercentage > 0 ? true : false;
  const discountApplied =
    discountPercentage && discountPercentage > 0 ? false : false;

  const ShowWording = () => {
    return displayName === false ? (
      <Section mt={2}>
        <Typography variant="h5">
          {`Here is your total`}{" "}
          <Typography variant="h5-bold">
            {`${frequencyDisplay[frequency]} premium`}
          </Typography>
        </Typography>
      </Section>
    ) : (
      <Section mt={2}>
        <Typography variant="h5">
          {`Hi ${firstName}, your total`}{" "}
          <Typography variant="h5-bold">
            {`${frequencyDisplay[frequency]} premium`}
          </Typography>{" "}
          is
        </Typography>
      </Section>
    );
  };

  return (
    <>
      {data ? <ShowWording /> : null}
      {data && isCoverStateValid === true && policyPremiumsTotal ? (
        <Section mt={2}>
          {/* Amount is either a single value or the combination of a two person quote  */}
          <Typography variant="h2-bold">{`${formatCurrency(
            policyPremiumsTotal[frequency]
          )}`}</Typography>
        </Section>
      ) : (
        <Skeleton
          sx={{ bgcolor: "#F1F9FA" }}
          animation="wave"
          variant="rounded"
          width={310}
          height={72}
        />
      )}
      {discountApplied ? <Discount /> : null}
    </>
  );
};
